import React from "react";
const DropdownOptions = (props: any) => {
    return (
        <tr className={"selection--option"} onClick={props.clickHandler} style={{
            borderBottom: "1px solid #e5e5e5"
        }}>
            <td className={"custom-radio"} style={{ textAlign: "center" }}>
                <div className={"form-check"}>
                    <label className={"form-check-label"}>
                        <input type="radio" name={props.type + "-input"} checked={props.checked}
                            className={"form-check-input tmg--radio"} value={props.id} onChange={() => { }} />&zwnj;
                    </label>
                </div>
            </td>
            <td className={"name"}>{props.name}</td>
        </tr>
    );
}

export default DropdownOptions